import React from 'react';
import type { OrganizerWithFollowStatus } from '@/src/listings/components/OrganizerCard/types';
import { OrganizerStats } from './OrganizerStats';
import { TopOrganizerLabel } from '@/src/listings/components/_shared/TopOrganizerLabel';
import { OrganizerNameWithBadge } from '@/src/listings/components/_shared/OrganizerNameWithBadge';
import styles from './OrganizerData.module.scss';
import { OrganizerAvatar } from './OrganizerAvatar/OrganizerAvatar';
import { useAppContext } from '@/src/listings/components/_shared/context/AppContext';

interface OrganizerDataProps {
  organizer: OrganizerWithFollowStatus;
}

export const OrganizerData: React.FC<OrganizerDataProps> = ({ organizer }) => {
  const { data: appContextData } = useAppContext();
  const domainUrl = appContextData.serverUrl;
  const isSuperOrganizer = organizer.superOrganizer === true;
  const isPremiumOrganizer = organizer.premiumOrganizer === true;

  return (
    <div className={styles.wrapper} data-testid="organizer-data">
      <div className={styles.avatarContainer}>
        <OrganizerAvatar organizer={organizer} />
      </div>
      <div className={styles.contentContainer}>
        {isSuperOrganizer && <TopOrganizerLabel />}
        <a
          href={`${domainUrl}/o/${organizer.id}`}
          className={styles.organizerName}
          target="_blank"
          rel="noopener noreferrer"
        >
          <OrganizerNameWithBadge name={organizer.name ?? ''} isPremiumOrganizer={isPremiumOrganizer} />
        </a>
        <OrganizerStats organizer={organizer} />
      </div>
    </div>
  );
};
